


















import { NavigationKind } from '@app/router/types';
import {
    defineComponent,
    PropType,
} from '@vue/composition-api';
import { Location } from 'vue-router';

export default defineComponent({
    name: 'SubtleLink',
    props: {
        link: {
            type: Object as PropType<Location>,
            required: true,
        },
        dynamic: {
            type: Boolean,
            default: false,
        },
    },
    setup(props) {
        return {
            destination: {
                kind: NavigationKind.SingleDomain,
                location: props.link,
            },
        };
    },
});
